// require('dotenv').config();

const requiredEnvVars = [
    'REACT_APP_WS_PORT',
    'REACT_APP_SHOW_RECIP',
];

// 检查必填环境变量
const missingVars = requiredEnvVars.filter(key => typeof process.env[key] === 'undefined');
if (missingVars.length > 0) {
    throw new Error(`缺少必要的环境变量: ${missingVars.join(', ')}`);
}


const config = {

    REACT_APP_WS_PORT: parseInt(process.env.REACT_APP_WS_PORT || '3000'),
    REACT_APP_SHOW_RECIP: Number(process.env.REACT_APP_SHOW_RECIP)
};

export default config;
